import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import constants from './ForgotPasswordConfig';

export class ForgotPasswordActionFilter extends BaseActionFilter {
    getForgotPasswordDL(store) {
        const { context } = store.getState();
        let deviceType = '';
        if (context.deviceType.isMobile) {
            deviceType = 'mobile';
        } else if (context.deviceType.isDesktop) {
            deviceType = 'desktop';
        } else {
            deviceType = 'tablet';
        }

        const forgotPasswordPageDL = this.updateCommonDigitalData();
        forgotPasswordPageDL.page.pageInfo.eventName = constants.EVENTNAME;
        forgotPasswordPageDL.page.pageInfo.pageType = constants.PAGETYPE;
        forgotPasswordPageDL.page.pageInfo.deviceType = deviceType;
        return forgotPasswordPageDL;
    }

    getSetPasswordFormError(error) {
        let getSetPasswordFormError = this.updateCommonDigitalData();
        getSetPasswordFormError = {
            error,
        };
        return getSetPasswordFormError;
    }

    getSetPasswordServiceError(payload) {
        const errorEventObject = [];
        const error = payload.response || {};

        if (error.errorMessage) {
            errorEventObject.push({
                errorDescription: error.errorMessage,
                errorID: error.errorCode || '',
            });
        }
        let getSetPasswordFormError = this.updateCommonDigitalData();
        getSetPasswordFormError = {
            error: errorEventObject,
        };
        return getSetPasswordFormError;
    }

    getAccountEmailSuccess(store) {
        const { context } = store.getState();
        let deviceType = '';
        if (context.deviceType.isMobile) {
            deviceType = 'mobile';
        } else if (context.deviceType.isDesktop) {
            deviceType = 'desktop';
        } else {
            deviceType = 'tablet';
        }

        const forgotPasswordPageDL = this.updateCommonDigitalData();
        forgotPasswordPageDL.page.pageInfo.pageType = 'account';
        // forgotPasswordPageDL.page.pageInfo.eventName = constants.EVENTNAME;
        forgotPasswordPageDL.page.pageInfo.siteSection = 'account';
        // forgotPasswordPageDL.page.pageInfo.analyticsPageName = '';
        forgotPasswordPageDL.page.pageInfo.pageName = 'reset password active';
        // forgotPasswordPageDL.page.pageInfo.eventName = 'reset password expired';
        // forgotPasswordPageDL.page.pageInfo.pageType = constants.PAGETYPE;
        forgotPasswordPageDL.page.pageInfo.searchRedirect = '';
        forgotPasswordPageDL.page.pageInfo.version = 'apollo 1 2017 redesign yoda account';
        forgotPasswordPageDL.page.pageInfo.deviceType = deviceType;
        forgotPasswordPageDL.page.pageInfo.releaseVersion = context.__RELEASEVERSION__;
        forgotPasswordPageDL.page.category = {};
        forgotPasswordPageDL.page.category.primaryCategory = 'account';
        forgotPasswordPageDL.page.category.subCategory1 = '';
        forgotPasswordPageDL.page.category.subCategory2 = '';
        forgotPasswordPageDL.page.category.department = 'account';
        return forgotPasswordPageDL;
    }

    getAccountEmailError(store, error) {
        const { context } = store.getState();
        let deviceType = '';
        if (context.deviceType.isMobile) {
            deviceType = 'mobile';
        } else if (context.deviceType.isDesktop) {
            deviceType = 'desktop';
        } else {
            deviceType = 'tablet';
        }

        const forgotPasswordPageDL = this.updateCommonDigitalData();
        forgotPasswordPageDL.page.pageInfo.pageType = 'account';
        // forgotPasswordPageDL.page.pageInfo.eventName = constants.EVENTNAME;
        forgotPasswordPageDL.page.pageInfo.siteSection = 'account';
        // forgotPasswordPageDL.page.pageInfo.analyticsPageName = '';
        forgotPasswordPageDL.page.pageInfo.pageName = 'reset password expired';
        // forgotPasswordPageDL.page.pageInfo.eventName = 'reset password expired';
        // forgotPasswordPageDL.page.pageInfo.pageType = constants.PAGETYPE;
        forgotPasswordPageDL.page.pageInfo.deviceType = deviceType;
        forgotPasswordPageDL.page.pageInfo.releaseVersion = context.__RELEASEVERSION__;
        forgotPasswordPageDL.page.category = {};
        forgotPasswordPageDL.page.category.primaryCategory = 'account';
        forgotPasswordPageDL.page.category.subCategory1 = '';
        forgotPasswordPageDL.page.category.subCategory2 = '';
        forgotPasswordPageDL.page.category.department = 'account';

        forgotPasswordPageDL.error = [];
        if (error.errorMessage) {
            forgotPasswordPageDL.error.push({
                errorDescription: error.errorMessage,
                errorID: error.errorCode || '',
            });
        }
        return forgotPasswordPageDL;
    }
}

export default ForgotPasswordActionFilter;
